<template>
  <div class="data-management">
    <h2 class="text-xl font-bold text-primary mb-4">Data Management</h2>
    <div class="mb-4 flex flex-wrap space-x-4">
      <select
        v-model="selectedDataType"
        @change="resetFiltersAndPagination"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
      >
        <option
          v-for="(value, key) in filteredDataTypes"
          :key="key"
          :value="key"
        >
          {{ value }}
        </option>
      </select>
      <div class="relative">
        <input
          v-model="searchQuery"
          @input="resetPagination"
          type="text"
          placeholder="Search..."
          class="border border-gray-300 rounded-md pl-10 pr-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <magnify-icon
          class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        />
      </div>
      <div v-if="showModuleFilter" class="relative">
        <div class="flex items-center">
          <input
            v-model="moduleSearch"
            @input="filterModules"
            type="text"
            placeholder="Search modules..."
            class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary flex-grow"
          />
          <button
            v-if="moduleSearch || selectedModule"
            @click="clearModuleSearch"
            class="ml-2 text-gray-500 hover:text-primary focus:outline-none"
            type="button"
          >
            <close-icon />
          </button>
        </div>
        <div
          v-if="showModuleDropdown"
          class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto"
        >
          <div
            v-for="module in filteredModules"
            :key="module.id"
            @click="selectModule(module)"
            class="px-3 py-2 cursor-pointer hover:bg-gray-100"
          >
            {{ module.moduleCode }} - {{ module.name }}
          </div>
        </div>
      </div>
      <select
        v-if="showSchoolFilter"
        v-model="selectedSchool"
        @change="handleSchoolChange"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
      >
        <option value="">All Schools</option>
        <option
          v-for="school in schools"
          :key="school.id"
          :value="school.shortName"
        >
          {{ school.shortName }}
        </option>
      </select>
      <select
        v-if="showDepartmentFilter"
        v-model="selectedDepartment"
        @change="resetPagination"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
      >
        <option value="">All Departments</option>
        <option
          v-for="dept in filteredDepartments"
          :key="dept.id"
          :value="dept.shortName"
        >
          {{ dept.shortName }}
        </option>
      </select>
    </div>
    <div class="mb-4">
      <button
        @click="openExcelModal"
        class="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-300 mr-2"
      >
        {{
          (selectedDataType == "moduleStaff" && userRole != "admin") ||
          userRole == "admin"
            ? "Upload/Download"
            : "Download"
        }}
      </button>
      <button
        v-if="
          (selectedDataType === 'studentModuleActivity' ||
          selectedDataType === 'activityStaff') && userRole == 'admin'
        "
        @click="openAddModal"
        class="bg-primary text-white px-4 py-2 rounded hover:bg-blue-900 transition duration-300 mr-2"
      >
        Add New Relationship
      </button>
      <button
        v-if="selectedDataType === 'modules'"
        @click="compareModal = true"
        class="bg-primary text-white px-4 py-2 rounded hover:bg-blue-900 transition duration-300 mr-2"
      >
        Compare SITS/S+
      </button>
      <!-- <button
        v-if="selectedDataType === 'moduleStaff'"
        @click="confirmModuleStaff"
        class="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 transition duration-300 mr-2"
      >
        Confirm
      </button>
      <button
        v-if="selectedDataType === 'moduleStaff'"
        @click="confirmAllModuleStaff"
        class="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition duration-300"
      >
        Confirm All
      </button>-->
      <input
        type="checkbox"
        v-model="showNoActModule"
        v-if="selectedDataType === 'moduleStaff'"
        class="ml-2 h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
      />
      <label
        for="showNoActModule"
        class="ml-1 mb-2 text-gray-600"
        v-if="selectedDataType === 'moduleStaff'"
        >Show No Activity Module</label
      >
    </div>
    <div class="bg-white shadow-md rounded-lg overflow-hidden">
      <table class="min-w-full table-fixed">
        <thead class="bg-primary text-white">
          <tr>
            <th
              v-for="header in headers"
              :key="header"
              class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
            >
              {{ formatHeader(header) }}
            </th>
            <th
              class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              v-if="
                selectedDataType != 'studentModuleActivity' &&
                selectedDataType != 'activityStaff' &&
                selectedDataType != 'moduleStaff'
              "
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in paginatedData" :key="item.id">
            <td
              v-for="header in headers"
              :key="header"
              class="whitespace-nowrap overflow-hidden text-ellipsis"
              :title="item[header]"
            >
              <!--   <template
                v-if="header === 'action' && selectedDataType === 'moduleStaff'"
              >
                <input
                  type="checkbox"
                  :id="'module-' + item.moduleCode + '-' + item.email"
                  :value="item.moduleCode + '-' + item.email"
                  v-model="selectedModuleStaff"
                  v-if="item.status == 'Not Confirmed'"
                  class="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                />
              </template>
-->
              <template
                v-if="header === 'image' && selectedDataType === 'staff'"
              >
                <img
                  v-if="item.image"
                  :src="item.image"
                  alt="Staff Image"
                  class="w-10 h-10 rounded-full object-cover cursor-pointer"
                  @click="openStaffImageModal(item)"
                />

                <span v-else class="text-gray-400">No image</span>
              </template>

              <template v-else-if="header == 'isFixed'">
                <span v-if="item[header]">Yes</span>
                <span v-else>No</span>
              </template>
              <template v-else-if="header == 'isExcluded'">
                <span v-if="item[header]">Yes</span>
                <span v-else>No</span>
              </template>
              <template
                v-else-if="
                  selectedDataType === 'studentModuleActivity' &&
                  (header === 'school' || header === 'department')
                "
              >
                {{ getModuleInfo(item.moduleCode, header) }}
              </template>
              <template v-else>
                {{ item[header] }}
              </template>
            </td>
            <!-- tmp fix, logic to be confirmed -->
            <td
              class="whitespace-nowrap space-x-2"
              v-if="
                selectedDataType != 'studentModuleActivity' &&
                selectedDataType != 'activityStaff' &&
                selectedDataType != 'moduleStaff'
              "
            >
              <button
                v-if="selectedDataType !== 'moduleStaff'"
                @click="openEditModal(item)"
                class="text-primary hover:text-primary-light"
              >
                <pencil-icon />
              </button>
              <button
                v-if="
                  selectedDataType === 'studentModuleActivity' ||
                  selectedDataType === 'activityStaff'
                "
                @click="deleteRelationship(item)"
                class="text-primary hover:text-primary-light"
              >
                <delete-icon />
              </button>
              <button
                @click="getUser(item)"
                v-if="selectedDataType == 'students'"
              >
                <account-icon />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-4 flex justify-between items-center">
      <div>
        <span class="text-gray-600">
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ totalCount }} entries
        </span>
        <span class="ml-5 text-gray-600 text-sm">
          Data originates from
          {{
            selectedDataType == "students" || selectedDataType == "staff"
              ? "SITS"
              : "University Timetabling System"
          }}
        </span>
      </div>
      <div class="flex items-center space-x-2">
        <button
          @click="prevPage"
          :disabled="currentPage === 1"
          class="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50"
          :class="{ 'hover:bg-primary hover:text-black': currentPage !== 1 }"
        >
          Previous
        </button>
        <select
          v-model="itemsPerPage"
          @change="resetPagination"
          class="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-primary text-sm"
        >
          <option
            v-for="option in itemsPerPageOptions"
            :key="option"
            :value="option"
          >
            {{ option }} / page
          </option>
        </select>
        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50"
          :class="{
            'hover:bg-primary hover:text-black': currentPage !== totalPages,
          }"
        >
          Next
        </button>
      </div>
    </div>

    <EditorModal
      :show="showModal"
      :is-adding="isAdding"
      :data-type="dataTypes[selectedDataType]"
      :editing-item="editingItem"
      :headers="headers"
      :schools="schools"
      :departments="departments"
      :students="students"
      :modules="modules"
      :activities="getActivities()"
      :fetch-activities-for-module="fetchActivitiesForModule"
      :staff-members="staff"
      @close="closeModal"
      @submit="handleSubmit"
    />

    <StaffImageModal
      :show="showStaffImageModal"
      :imageUrl="selectedStaffImage"
      :staffName="selectedStaffName"
      @close="showStaffImageModal = false"
    />
    <ExcelModal
      :show="showExcelModal"
      :data-type="dataTypes[selectedDataType]"
      :role="userRole"
      :isNoAct="showNoActModule"
      @close="closeExcelModal"
    />
    <BulkImageUpload
      v-if="showBulkImageUpload"
      @imagesUploaded="handleImagesUploaded"
    />
    <div
      v-if="compareModal"
      class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50"
    >
      <div class="bg-white p-8 rounded-lg shadow-xl w-full" style="max-width: 800px">
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-2xl font-semibold text-primary">Compare SITS/S+</h3>
          <button
            @click="compareModal = false"
            class="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
        <div class="mb-8">
          <!-- table -->
          <table class="min-w-full table-fixed">
            <thead class="bg-primary text-white">
              <tr>
                <th>Module Code</th>
                <th>Module Name</th>
                <th>Department</th>
                <th>SITS Department</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="item in compareResult" :key="item.moduleCode">
                <td>{{ item.moduleCode }}</td>
                <td>{{ item.moduleName }}</td>
                <td>{{ item.moduleDepartment }}</td>
                <td>{{ item.moduleDepartmentSITS }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50"
    >
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import EditorModal from "./modals/EditorModal.vue";
import StaffImageModal from "./modals/StaffImageModal.vue";
import ExcelModal from "./modals/ExcelModal.vue";
import BulkImageUpload from "./BulkImageUpload.vue";
import { dataApi } from "../api/dataManagement";
import { reportsApi } from "../api/reports";
import { userApi } from "../api/userManagement";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import AccountIcon from "vue-material-design-icons/Account.vue";

import { mapState, mapActions } from "vuex";
import debounce from "lodash.debounce";

export default {
  name: "DataManagement",
  components: {
    EditorModal,
    StaffImageModal,
    ExcelModal,
    BulkImageUpload,
    MagnifyIcon,
    CloseIcon,
    PencilIcon,
    DeleteIcon,
    AccountIcon,
  },
  data() {
    return {
      dataTypes: {
        students: "Students",
        staff: "Staff",
        modules: "Modules",
        studentModuleActivity: "Student/Module/Activity",
        activityStaff: "Activity/Staff",
        moduleStaff: "Module/Staff",
      },
      selectedDataType: "students",
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 25, 50, 100],
      showModal: false,
      isAdding: false,
      editingItem: null,
      searchQuery: "",
      selectedSchool: "",
      selectedDepartment: "",
      moduleSearch: "",
      selectedModule: null,
      showModuleDropdown: false,
      showStaffImageModal: false,
      selectedStaffImage: null,
      selectedStaffName: "",
      loading: false,
      data: [],
      totalCount: 0,
      students: [],
      showExcelModal: false,
      showBulkImageUpload: false,
      confirmedModuleStaff: [],
      selectedModuleStaff: [],
      showNoActModule: false,
      compareModal: false,
      compareResult: []
    };
  },
  computed: {
    filteredDataTypes() {
      if (this.userRole == "admin" || this.userRole == "supervisor")
        return this.dataTypes;
      else
        return {
          staff: "Staff",
          //studentModuleActivity: 'Student/Module/Activity',
          activityStaff: "Activity/Staff",
          moduleStaff: "Module/Staff",
        };
    },
    ...mapState({
      schools: (state) => state.schools,
      departments: (state) => state.departments,
      modules: (state) => state.modules,
      staff: (state) => state.staff,
      userRole: (state) => state.auth.userRole,
      userSchool: (state) => state.auth.userSchool,
      userDepartment: (state) => state.auth.userDepartment,
    }),
    filteredSchools() {
      if (this.userRole === "admin") {
        return this.schools;
      } else if (this.userRole === "school_admin") {
        return [this.userSchool];
      } else if (this.userRole === "department_admin") {
        return this.departments.find((d) => d.shortName === this.userDepartment)
          .school;
      }
    },
    headers() {
      if (this.selectedDataType === "moduleStaff") {
        return [
          //"action",
          "moduleCode",
          "moduleName",
          "school",
          "department",
          "staff",
          "email",
          "activityCount",
          "status",
        ];
      }
      let result =
        this.data.length > 0
          ? Object.keys(this.data[0]).filter((key) => key !== "id")
          : [];
      if (this.selectedDataType == "studentModuleActivity") {
        result = result.filter((x) => x != "school" && x != "department");
      }
      return result;
    },
    paginatedData() {
      return this.data;
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.totalCount);
    },
    filteredDepartments() {
      if (!this.selectedSchool) return this.departments;
      return this.departments.filter(
        (dept) => dept.school === this.selectedSchool
      );
    },
    showSchoolFilter() {
      return [
        "students",
        "staff",
        "modules",
        "activityStaff",
        "moduleStaff",
      ].includes(this.selectedDataType);
    },
    showDepartmentFilter() {
      return ["staff", "modules", "activityStaff", "moduleStaff"].includes(
        this.selectedDataType
      );
    },
    showModuleFilter() {
      return ["studentModuleActivity", "activityStaff", "moduleStaff"].includes(
        this.selectedDataType
      );
    },
    filteredModules() {
      return this.modules
        ? this.modules.filter(
            (module) =>
              module.moduleCode
                .toLowerCase()
                .includes(this.moduleSearch.toLowerCase()) ||
              module.name
                .toLowerCase()
                .includes(this.moduleSearch.toLowerCase())
          )
        : [];
    },
  },
  watch: {
    selectedDataType() {
        this.fetchDataFromApi();    
      //alert("selectedDataType changed");
    },
    showNoActModule() {
      if (this.selectedDataType === "moduleStaff") {
        this.fetchDataFromApi();
      }
    },
    compareModal() {
      if (this.compareModal) {
        this.compareSitsPlus();
      }
    },
  },
  methods: {
    ...mapActions(["fetchAllData"]),
    formatHeader(header){
      //alert(header)
      header = this.convertString(header)
      return header.replace("school","school/academy")
    },  
    convertString(header){
      return header.replace(/([A-Z])/g, ' $1').trim();
    },
    async compareSitsPlus(){
      this.compareResult = await reportsApi.compareSitsPlus();
    },
    async getUser(user) {
      let tokenResult = await userApi.getToken(user.email);
      let url =
        process.env.VUE_APP_STUDENT +
        "student/#access_token=" +
        tokenResult.token;
      localStorage.removeItem("student-session-authorization");
      window.open(url, "_blank");
    },
    async fetchActivitiesForModule(moduleCode) {
      try {
        const filters = {
          searchQuery: "",
          selectedSchool: "",
          selectedDepartment: "",
          selectedModule: moduleCode,
        };
        const result = await dataApi.fetchData("activities", 1, 999, filters);
        const activities = result.items;
        return activities;
      } catch (error) {
        console.error("Error fetching activities for module:", error);
        return [];
      }
    },
    async fetchDataFromApi() {
      this.loading = true;

      const filters = {
        searchQuery: this.searchQuery,
        school:
          this.selectedDataType === "moduleStaff"
            ? this.selectedSchool
            : this.getSchoolFullName(this.selectedSchool),
        department:
          this.selectedDataType === "moduleStaff"
            ? this.selectedDepartment
            : this.getDepartmentFullName(this.selectedDepartment),
        moduleCode: this.selectedModule ? this.selectedModule.moduleCode : "",
      };
      console.log("filters");
      console.log(filters);
      try {
        let result;
        if (this.selectedDataType === "moduleStaff") {
          result = this.showNoActModule
            ? await reportsApi.getModuleStaffNoActReport({
                ...filters,
                page: this.currentPage,
                pageSize: this.itemsPerPage,
              })
            : await reportsApi.getModuleStaffReport({
                ...filters,
                page: this.currentPage,
                pageSize: this.itemsPerPage,
              });

          console.log(result);

          this.data = result.items.map((item) => ({
            ...item,
            staff: this.showNoActModule ? "" : item.staff.name,
            email: this.showNoActModule ? "" : item.staff.email,
          }));
        } else {
          result = await dataApi.fetchData(
            this.selectedDataType,
            this.currentPage,
            this.itemsPerPage,
            filters
          );
          this.data = result.items;
        }

        this.totalCount = result.totalCount;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },
    getSchoolFullName(shortName) {
      if (!shortName) return "";
      const school = this.schools.find((s) => s.shortName === shortName);
      return school ? school.fullName : "";
    },
    getDepartmentFullName(shortName) {
      if (!shortName) return "";
      const department = this.departments.find(
        (d) => d.shortName === shortName
      );
      return department ? department.fullName : "";
    },
    resetFiltersAndPagination() {
      this.searchQuery = "";
      this.selectedSchool = "";
      this.selectedDepartment = "";
      this.moduleSearch = "";
      this.selectedModule = null;
      this.resetPagination();
    },
    //resetPagination() {
    //  this.currentPage = 1;
    //  this.fetchDataFromApi();
    //},
    resetPagination: debounce(function () {
      this.fetchDataFromApi();
      this.currentPage = 1;
    }, 500),
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchDataFromApi();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchDataFromApi();
      }
    },
    openEditModal(item) {
      this.editingItem = { ...item };
      this.showModal = true;
      this.isAdding = false;
    },
    openAddModal() {
      this.editingItem = {};
      this.headers.forEach((header) => {
        this.editingItem[header] = "";
        if (header == "isFixed") this.editingItem[header] = true;
      });
      this.showModal = true;
      this.isAdding = true;
    },
    closeModal() {
      this.showModal = false;
      this.editingItem = null;
      this.isAdding = false;
    },
    async handleSubmit(updatedItem) {
      try {
        if (this.isAdding) {
          await dataApi.createItem(this.selectedDataType, updatedItem);
        } else {
          await dataApi.updateItem(
            this.selectedDataType,
            updatedItem.id,
            updatedItem
          );
        }
        this.closeModal();
        this.fetchDataFromApi();
      } catch (error) {
        console.error("Error submitting data:", error);
      }
    },
    async deleteRelationship(item) {
      try {
        if (!confirm("Are you sure you want to delete this relationship?"))
          return;
        await dataApi.deleteItem(this.selectedDataType, item.id);
        this.fetchDataFromApi();
      } catch (error) {
        console.error("Error deleting relationship:", error);
      }
    },
    handleSchoolChange() {
      this.selectedDepartment = "";
      this.resetPagination();
    },
    filterModules() {
      this.showModuleDropdown = true;
    },
    selectModule(module) {
      this.selectedModule = module;
      this.moduleSearch = `${module.moduleCode} - ${module.name}`;
      this.showModuleDropdown = false;
      this.resetPagination();
    },
    clearModuleSearch() {
      this.moduleSearch = "";
      this.selectedModule = null;
      this.showModuleDropdown = false;
      this.resetPagination();
    },
    openStaffImageModal(staff) {
      this.selectedStaffImage = staff.image;
      this.selectedStaffName =
        staff.name || `${staff.firstName} ${staff.lastName}`;
      this.showStaffImageModal = true;
    },
    getActivities() {
      const activities = new Set();
      if (this.data.studentModuleActivity) {
        this.data.studentModuleActivity.forEach((item) =>
          activities.add(item.activityId)
        );
      }
      if (this.data.activityStaff) {
        this.data.activityStaff.forEach((item) =>
          activities.add(item.activityId)
        );
      }
      return Array.from(activities).map((activityId) => ({ activityId }));
    },
    getModuleInfo(moduleCode, field = null) {
      const module = this.modules
        ? this.modules.find((m) => m.moduleCode === moduleCode)
        : null;
      if (!module) return "N/A";
      if (field) return module[field];
      return module;
    },
    openExcelModal() {
      this.showExcelModal = true;
    },
    closeExcelModal() {
      this.showExcelModal = false;
    },
    handleImagesUploaded() {
      this.showBulkImageUpload = false;
      this.fetchDataFromApi();
    },
    async fetchModuleStaffStatus() {
      this.confirmedModuleStaff = await dataApi.fetchData(
        "moduleStaff",
        1,
        999,
        filters
      );
    },
    async confirmModuleStaff() {
      let yes = confirm(
        "Do you want to confirm these module/staff relationship"
      );
      if (!yes) return;
      if (this.selectedModuleStaff.length == 0) return;
      await dataApi.createItem(this.selectedDataType, this.selectedModuleStaff);
      this.selectedModuleStaff = [];
      await this.fetchDataFromApi();
    },
    async confirmAllModuleStaff() {
      let yes = confirm(
        "Do you want to confirm these module/staff relationship"
      );
      if (!yes) return;
      this.selectedModuleStaff = this.data.map(
        (o) => o.moduleCode + "-" + o.email
      );
      await dataApi.createItem(this.selectedDataType, this.selectedModuleStaff);
      this.selectedModuleStaff = [];
      await this.fetchDataFromApi();
    },
  },
  mounted(){
    this.fetchDataFromApi();
    this.fetchAllData();
    if (this.userRole != "admin") {
      this.selectedDataType = "staff";
    }
  },
  created() {
    this.fetchDataFromApi();
    this.fetchAllData();
    if (this.userRole != "admin") {
      this.selectedDataType = "staff";
    }
  },
};
</script>

<style scoped>
td {
  max-width: 200px;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

td:hover {
  overflow: visible;
  white-space: normal;
  word-break: break-word;
  position: relative;
  z-index: 1;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@media (max-width: 1024px) {
  td {
    max-width: 50px;
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
